export default function Stat_Standard_Deviation() {
  return <div>Stat_Standard_Deviation Component</div>;
}
